import { createContext } from "react";
import { promotionsContextType } from "../types/promotionTypes";

const PromotionsContext = createContext<undefined|promotionsContextType>(undefined);

export { PromotionsContext };
